import React, { useEffect, useState } from 'react';
import { FormGroup, Input } from 'reactstrap';
import { maskPhone } from 'services/Utils';
import { formatNumber } from 'services/Utils';
import { maskBankAccount } from 'services/Utils';
import { maskCEP } from 'services/Utils';
import { maskCPF } from 'services/Utils';
import { onlyNumbers } from 'services/Utils';
import { onlyNumbersAndInitialMinus } from 'services/Utils';
import { maskCNPJ } from 'services/Utils';

export function getData(data, field) {
  if (!data) return null
  return field.split('.').reduce((obj, key) => obj ? obj[key] : null, data)
}

export function getError(data, field) {
  if (!data || !data.errors) return null
  const error = data.errors.find(el => el.fieldName == field)
  return error ? error.error : null
}

export function GFTextField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      {props.label && <label htmlFor={props.name}>{props.label}</label>}
      <Input id={props.name} type="text" value={value || ''} onChange={e => props.onChange && props.onChange(props.name, e.target.value)} disabled={props.disabled || props.formDisabled} placeholder={props.placeholder} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFCNPJField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={maskCNPJ(value) || ''} onChange={e => props.onChange && props.onChange(props.name, onlyNumbers(e.target.value))} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFCPFField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={maskCPF(value) || ''} onChange={e => props.onChange && props.onChange(props.name, onlyNumbers(e.target.value))} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFCEPField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={maskCEP(value) || ''} onChange={e => props.onChange && props.onChange(props.name, onlyNumbers(e.target.value))} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFPhoneField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={value || ''} onChange={e => props.onChange && props.onChange(props.name, maskPhone(e.target.value))} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFBankAccountField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={value || ''} onChange={e => props.onChange && props.onChange(props.name, maskBankAccount(e.target.value))} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFComboField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)

  const handleChange = (value) => {
    props.onChange && props.onChange(props.name, value)
  }

  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <select className="form-control" value={value || ''} onChange={e => e.target.value ? handleChange(e.target.value) : handleChange(null)} disabled={props.disabled || props.formDisabled}>
        {props.showDefault && (
          <option value="">{props.defaultValue || 'Selecione'}</option>
        )}
        {props.options.map(el => (
          <option key={el[props.optionValue || 'value']} value={el[props.optionValue || 'value']}>{el[props.optionLabel || 'label']}</option>
        ))}
      </select>
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFCheckboxField(props) {
  const value = getData(props.data, props.name)
  return (
    <FormGroup className={`d-flex flex-column justify-content-end col-${props.colspan || 12}`}>
      <div className='d-flex flex-row align-items-center justify-content-start' style={{ height: 43, gap: 10 }}>
        <input id={props.name} type="checkbox" checked={value} onChange={e => props.onChange && props.onChange(props.name, e.target.checked)} className='ml-0' disabled={props.disabled || props.formDisabled} />
        <label htmlFor={props.name} className='mb-0'>{props.label}</label>
      </div>
    </FormGroup>
  )
}

export function GFRadioField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)

  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      {props.label && <label htmlFor={props.name}>{props.label}</label>}
      <div style={{ display: 'flex', flexDirection: 'row', columnGap: 16 }}>
        {props.options.map(el => (
          <div className='d-flex flex-row align-items-center justify-content-start' style={{ height: 43, gap: 10 }}>
            <input id={`${props.name}-${el.value}`} type="radio" checked={value === el.value} onChange={e => props.onChange && props.onChange(props.name, el.value)} className='ml-0' disabled={props.disabled || props.formDisabled} />
            <label htmlFor={`${props.name}-${el.value}`} className='mb-0'>{el.label}</label>
          </div>
        ))}
      </div>
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFIntegerField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="number" value={value || ''} onChange={e => props.onChange && props.onChange(props.name, e.target.value ? parseInt(e.target.value) : null)} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFDecimalField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)

  const handleChange = (e) => {
    const value = props.signed ? onlyNumbersAndInitialMinus(e.target.value) : onlyNumbers(e.target.value)
    if (value === '') {
      props.onChange && props.onChange(props.name, null)
    } else {
      const decimals = props.decimals || 2
      const newValue = parseFloat(value) / (10 ** decimals)
      props.onChange && props.onChange(props.name, newValue)
    }
  }

  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="text" value={value ? formatNumber(value, props.decimals || 2) : ''} onChange={handleChange} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFTextAreaField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)
  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      {props.label && <label htmlFor={props.name}>{props.label}</label>}
      <Input
        id={props.name}
        type="textarea"
        value={value || ''}
        onChange={e => props.onChange && props.onChange(props.name, e.target.value)}
        style={props.style}
        disabled={props.disabled || props.formDisabled}
        placeholder={props.placeholder}
      />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFDateField(props) {
  const value = getData(props.data, props.name)
  const error = getError(props.data, props.name)

  const formatDateToInput = (value) => {
    if (!value) return ''
    const dateValue = value instanceof Date ? value : new Date(value)
    if (dateValue.toString() === 'Invalid Date') return ''

    const ano = dateValue.getFullYear()
    const mes = String(dateValue.getMonth() + 1).padStart(2, '0')
    const dia = String(dateValue.getDate()).padStart(2, '0')
    return `${ano}-${mes}-${dia}`
  }

  const [inputValue, setInputValue] = useState(formatDateToInput(value))

  useEffect(() => {
    setInputValue(formatDateToInput(value))
  }, [value])

  const handleChange = (rawValue) => {
    setInputValue(rawValue || '')

    if ((rawValue || '') === '') {
      props.onChange && props.onChange(props.name, null)
      return
    }

    if ((rawValue || '').length < 10) {
      return
    }

    const match = (rawValue || '').match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) return

    const ano = parseInt(match[1], 10)
    const mes = parseInt(match[2], 10)
    const dia = parseInt(match[3], 10)
    if (!ano || !mes || !dia || ano < 1970) return

    const parsedDate = new Date(ano, mes - 1, dia)
    const isSameDate = parsedDate.getFullYear() === ano &&
      parsedDate.getMonth() + 1 === mes &&
      parsedDate.getDate() === dia

    if (parsedDate.toString() === 'Invalid Date' || !isSameDate) {
      return
    }

    props.onChange && props.onChange(props.name, parsedDate)
  }

  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name}>{props.label}</label>
      <Input id={props.name} type="date" value={inputValue} onChange={e => handleChange(e.target.value)} disabled={props.disabled || props.formDisabled} />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}

export function GFTitleField(props) {
  return (
    <div className={`col-${props.colspan || 12}`}>
      <h3>{props.label}</h3>
    </div>
  )
}

export function GFReadonlyTextField(props) {
  const valueFromData = props.name ? getData(props.data, props.name) : null
  const value = props.value !== undefined ? props.value : valueFromData
  const error = props.name ? getError(props.data, props.name) : null

  return (
    <FormGroup className={`col-${props.colspan || 12}`}>
      <label htmlFor={props.name || props.label}>{props.label}</label>
      <Input
        id={props.name || props.label}
        type="text"
        value={value || ''}
        readOnly
        disabled={props.disabled || props.formDisabled}
      />
      {error && <div className='text-danger'>* {error}</div>}
    </FormGroup>
  )
}


function FormField(props) {
  if (props.type === 'text')
    return <GFTextField {...props} />

  if (props.type === 'cnpj')
    return <GFCNPJField {...props} />

  if (props.type === 'cpf')
    return <GFCPFField {...props} />

  if (props.type === 'combo')
    return <GFComboField {...props} />

  if (props.type === 'checkbox')
    return <GFCheckboxField {...props} />

  if (props.type === 'integer')
    return <GFIntegerField {...props} />

  if (props.type === 'decimal')
    return <GFDecimalField {...props} />

  if (props.type === 'signeddecimal')
    return <GFDecimalField {...props} signed />

  if (props.type === 'textarea')
    return <GFTextAreaField {...props} />

  if (props.type === 'cep')
    return <GFCEPField {...props} />

  if (props.type === 'date')
    return <GFDateField {...props} />

  if (props.type === 'phone')
    return <GFPhoneField {...props} />

  if (props.type === 'bankAccount')
    return <GFBankAccountField {...props} />

  if (props.type === 'title')
    return <GFTitleField {...props} />

  if (props.type === 'readonlytext')
    return <GFReadonlyTextField {...props} />

  if (props.type === 'radio')
    return <GFRadioField {...props} />

  if (props.type === 'view')
    return (
      <div className={`col-${props.colspan || 12}`}>
        <props.component {...props} />
      </div>
    )

  if (props.separator) {
    return (
      <div className='col-12'>
        <hr />
      </div>
    )
  }

  return
}

export default function GeneralForm({ config, data, onChange, disabled }) {
  return (
    <>
      {config.map((linha, i) => (
        <div className="row" key={i}>
          {linha.filter(field => !field.hide).map((field, i) => {
            return (
              <FormField
                key={field.name || 'idx' + i}
                {...field}
                data={data}
                onChange={onChange}
                formDisabled={disabled}
              />
            )
          })}
        </div>
      ))}
    </>
  )
}

